var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.employee && !_vm.user)?_c('Profile'):(!_vm.employee && _vm.user == 'admin')?_c('AdminProfile'):_c('div',[_vm._v("NO PROFILE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }